module.exports = __webpack_public_path__ + "static/r22-6e664d5df8cd01071685f735b9c8a365.jpg";